import script from "./SkillsManDetailSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./SkillsManDetailSettings.vue?vue&type=script&setup=true&lang=js"

import "./SkillsManDetailSettings.vue?vue&type=style&index=0&id=4c07db08&lang=css"

const __exports__ = script;

export default __exports__